import { render, staticRenderFns } from "./CustomNotificationModal.vue?vue&type=template&id=47b8cdc2"
import script from "./CustomNotificationModal.vue?vue&type=script&lang=js"
export * from "./CustomNotificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports